interface WindowDimensions {
  usableHeight: number
  usableWidth: number
}

export const calculateUsableDimensions = (
  height: number,
  width: number,
  aspectRatio: number
): WindowDimensions => {
  let usableHeight = height
  let usableWidth = width

  // too tall
  if (height > width * aspectRatio) {
    while (usableHeight / usableWidth > aspectRatio) {
      while (usableHeight / aspectRatio > width) {
        usableHeight = usableHeight - 1
        usableWidth = usableHeight / aspectRatio
      }
    }
  }

  // too wide
  if (width > height / aspectRatio) {
    while (usableHeight / usableWidth < aspectRatio) {
      while (usableWidth * aspectRatio > height) {
        usableWidth = usableWidth - 1
        usableHeight = usableWidth * aspectRatio
      }
    }
  }

  return { usableHeight, usableWidth }
}
